"use strict";
import { useCallback, useMemo } from "react";
import { useCurrentLocale } from "features/language/hooks";
import {
  addFiatSymbolToNumber,
  formatCurrencyAmount,
  formatNumberOrString,
  formatPercent
} from "utilities/src/format/localeBased";
import { NumberType } from "utilities/src/format/types";
export function useLocalizedFormatter() {
  const locale = useCurrentLocale();
  const formatNumberOrStringInner = useCallback(
    ({ value, type = NumberType.TokenNonTx, currencyCode, placeholder }) => formatNumberOrString({ price: value, locale, currencyCode, type, placeholder }),
    [locale]
  );
  const formatCurrencyAmountInner = useCallback(
    ({ value, type, placeholder }) => formatCurrencyAmount({ amount: value, locale, type, placeholder }),
    [locale]
  );
  const formatPercentInner = useCallback(
    (value) => formatPercent(value, locale),
    [locale]
  );
  const addFiatSymbolToNumberInner = useCallback(
    ({ value, currencyCode, currencySymbol }) => addFiatSymbolToNumber({ value, currencyCode, currencySymbol, locale }),
    [locale]
  );
  return useMemo(
    () => ({
      formatNumberOrString: formatNumberOrStringInner,
      formatCurrencyAmount: formatCurrencyAmountInner,
      formatPercent: formatPercentInner,
      addFiatSymbolToNumber: addFiatSymbolToNumberInner
    }),
    [formatNumberOrStringInner, formatCurrencyAmountInner, formatPercentInner, addFiatSymbolToNumberInner]
  );
}
